import { RootState } from '../types'

export const getProfiles = (state: RootState) => state.profiles.profiles

export const getTotalProfiles = (state: RootState) => state.profiles.count

export const isValidating = (state: RootState) => state.profiles.isValidating

export const isLoading = (state: RootState) => state.profiles.isLoading

export const selectedProfile = (state: RootState) => state.profiles.selectedProfile

export const getProfileValidationResult = (state: RootState) => state.profiles.validationResult

export const isSaving = (state: RootState) => state.profiles.isSaving

export const searchParams = (state: RootState) => state.profiles.searchParameters
